import React from "react"
import { ListGroupItem } from "react-bootstrap"
import { Link } from "react-router"

export default function ReportLinkItem({ url, title, disabled }) {
  return <ListGroupItem className="menu-link-item" disabled={ disabled } title={ title }>
    { disabled ? title : <Link to={ url }>{ title }</Link> }
  </ListGroupItem>
}



// WEBPACK FOOTER //
// ./src/components/Reports/ReportLinkItem.js